import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Chip from '@material-ui/core/Chip'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  container: {
    width: '100%',
    minHeight: '30px',
    marginTop: '30px',
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'center'
  },
  chipContainer: {
    display: 'flex',
    justifyContent: 'center',
    height: '30px'
  },
  chip: {
    height: '30px',
    width: '100%',
    color: theme.palette.primary.main
  }
})
class TimeChipComponent extends Component {
  static propTypes = {
    date: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired
  }
  static defaultProps = {
    startDate: moment().format()
  }

  render() {
    const { date, classes } = this.props
    return (
      <div className={classes.container}>
        <div className={classes.chipContainer}>
          <Chip label={date} className={classes.chip} />
        </div>
      </div>
    )
  }
}
export default withStyles(styles)(TimeChipComponent)



// WEBPACK FOOTER //
// ./src/routes/History/components/TimeChipComponent.js